import ReceivedImageMessage from './ImageMessage/ReceivedImageMessage';
import SentImageMessage from './ImageMessage/SentImageMessage';
import { getMessageTime } from '../../../utils/time';

interface ImageMessageProps {
  id: number;
  direction: string;
  created: string;
  image: {
    media: string;
    msg: string;
    fname: string;
    dname: string;
    time: string;
    lat?: string | null;
    lng?: string | null;
  };
  error?: boolean;
}

const ImageMessage = ({ id, direction, created, image, error }: ImageMessageProps) => {
  const { time } = getMessageTime(created);

  if (direction === 'received') {
    return (
      <ReceivedImageMessage
        id={id}
        created={created}
        time={time}
        image={image}
      />
    );
  } else {
    return (
      <SentImageMessage id={id} created={created} time={time} image={image} error={error}/>
    );
  }
};

export default ImageMessage;
